import React from "react";
import { Link } from "react-router";
import axios from "axios";

export default class Intro extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            onboarding_state: null
        };
    }

    handleSubmit = async () => {
        await axios.patch("/v1/users/self/", {
            onboarding_state: APP_CONFIG.onboarding_state
        });

        window.location = "/";
    };

    async componentDidMount() {
        const { data } = await axios.get("/v1/users/self/");

        this.setState({
            onboarding_state: data.onboarding_state
        });
    }

    render() {
        return (
            <div className="content-container">
                <div className="section-top">
                    <h1>Welkom bij NIBHV Portaal</h1>
                </div>

                <div className="content text-links">
                    <p>
                        NIBHV hecht veel waarde aan de privacy. In ons <Link to="/privacy">privacy statement</Link> leggen we uit hoe we jouw privacy en die van anderen
                        bewaken.
                    </p>
                    <p>
                        Om gebruik te kunnen maken van NIBHV Portaal moet je akkoord gaan met onze <Link to="/terms-of-use">gebruiksvoorwaarden</Link>.
                    </p>
                </div>

                <button className="btn btn-primary" onClick={this.handleSubmit}>
                    Ik ga akkoord
                </button>
            </div>
        );
    }
}
